const state= {
    Items:{
        items:[],
        total:0,
    }
};

const getters = {
    Items : (state) => state.Items,
};


const actions = {
    async getItems({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/nlt-escalation-mapping`, {params:params})
                .then(response => {
                    commit( 'setItems', response.data.data );
                    resolve( response.data.data );
                })
                .catch(error => reject( error ));
        });
    },
    async saveItem({commit}, data){
        return new Promise (( resolve, reject ) => {
            global.axios.post(`api/nlt-escalation-mapping`, data)
                .then(response => {
                    resolve( response.data.data );
                })
                .catch(error => reject( error ));
        });
    },
    async updateItem({commit}, data){
        return new Promise (( resolve, reject ) => {
            global.axios.put(`api/nlt-escalation-mapping/${data.id}`, data)
                .then(response => {
                    resolve( response.data.data );
                })
                .catch(error => reject( error ));
        });
    },
    async deleteItems({commit}, ids){
        return new Promise (( resolve, reject ) => {
            global.axios.delete(`api/nlt-escalation-mapping`, {
                data:{
                    ids: ids
                }
            })
                .then(response => {
                    resolve( response.data.data );
                })
                .catch(error => reject( error ));
        });
    },
    
    async exportExcel({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/nlt-escalation-mapping/export`, {
                    params:params,
                    responseType: 'blob'})
                .then(response => {
                    resolve(response);
                })
                .catch(error => reject( error ));
        });
    },
}

const mutations = {
    setItems (state, data) {
        state.Items = data;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
